import React, { ReactNode, useCallback, useEffect } from 'react';
import { CloseIcon } from '../icons/Close';

const classNames = require('html-classnames');

interface ModalProps {
  onClose: () => void,
  hoveringClose?: boolean,
  withVideo?: boolean,
  children?: ReactNode,
}

export const Modal: React.FC<ModalProps> = ({
  onClose,
  children,
  hoveringClose,
  withVideo = false,
}: ModalProps) => {
  const hoveringCloseSane = hoveringClose || false;

  const modalClasses = classNames('modal', {
    '--with-video': withVideo,
  });
  const closeClasses = classNames('modal__close', { '--hovering': hoveringCloseSane });
  const contentClasses = classNames('modal__content', { '--hovering': hoveringCloseSane });

  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    const handler = (event: any) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keyup', handler);

    return () => {
      document.body.style.overflowY = 'auto';
      document.removeEventListener('keyup', handler);
    };
  });

  const handleGlobalClick = useCallback((event: any) => {
    if (event?.target === event?.currentTarget) {
      onClose();
    }
  }, []);
  return (
    <div
      className={modalClasses}
      onClick={handleGlobalClick}
    >
      <div className="modal__window">
        <div className={closeClasses}>
          <button
            type="button"
            onClick={onClose}
            aria-label="Kliknij by zamknąć okienko."
          >
            <CloseIcon />
          </button>
        </div>
        <div className={contentClasses}>
          {children}
        </div>
      </div>
    </div>
  );
};
